import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const testimonials = [{
  quote: 'Increíble la atención. Mi perro le tenía terror al veterinario y acá entra moviendo la cola. La paciencia que tienen vale oro.',
  owner: 'Sofía M.',
  pet: 'Dueña de Max 🐕',
  color: 'bg-primary',
  rotate: '-rotate-2'
}, {
  quote: 'Tuvimos una urgencia un domingo a la noche y nos salvaron. El Dr. Martín fue súper claro y nos contuvo en todo momento.',
  owner: 'Lucas y Flor',
  pet: 'Dueños de Salem 🐈',
  color: 'bg-secondary',
  rotate: 'rotate-2'
}, {
  quote: 'Desde que cambiamos la dieta con la Lic. Camila, mi perra tiene más energía y el pelo le brilla un montón. ¡Súper recomendados!',
  owner: 'Andrea G.',
  pet: 'Dueña de Lola 🐩',
  color: 'bg-accent',
  rotate: '-rotate-1'
}];
export const Testimonials: React.FC = () => {
  return <section id="testimonios" className="py-24 bg-bg overflow-hidden relative" data-id="element-158">
      {/* Decorative blobs */}
      <div className="absolute top-40 left-10 w-32 h-32 bg-white border-3 border-text rounded-full opacity-50 blob-1" data-id="element-159"></div>
      <div className="absolute bottom-20 right-10 w-48 h-48 bg-white border-3 border-text rounded-full opacity-50 blob-2" data-id="element-160"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-161">
        <SectionHeading title="Lo que dicen los dueños felices" data-id="element-162" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-16 max-w-6xl mx-auto" data-id="element-163">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className={`flex flex-col transform ${testimonial.rotate}`} data-id="element-164">
              {/* Chat Bubble */}
              <div className={`${testimonial.color} border-3 border-text rounded-3xl p-8 neo-shadow-lg mb-8 relative z-10 chat-bubble-tail chat-bubble-tail-border`} data-id="element-165">
                <div className="flex gap-1 mb-4 text-2xl" data-id="element-166">⭐⭐⭐⭐⭐</div>
                <p className="font-bold text-xl leading-relaxed" data-id="element-167">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Author Info */}
              <div className="pl-8 flex items-center gap-4" data-id="element-168">
                <div className="bg-white border-2 border-text rounded-full w-12 h-12 flex items-center justify-center text-xl neo-shadow-sm" data-id="element-169">
                  👤
                </div>
                <div data-id="element-170">
                  <h4 className="font-black text-lg" data-id="element-171">{testimonial.owner}</h4>
                  <p className="font-bold text-gray-600 text-sm" data-id="element-172">
                    {testimonial.pet}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};